export default {"src":"/_next/static/media/ic-done.94ec8f3f.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};